module.exports = {"510322100":"富世镇","510322101":"东湖镇","510322102":"琵琶镇","510322103":"狮市镇","510322104":"骑龙镇","510322107":"互助镇","510322111":"代寺镇","510322112":"中石镇","510322113":"童寺镇","510322114":"古佛镇","510322115":"永年镇","510322116":"彭庙镇","510322117":"兜山镇","510322118":"板桥镇","510322119":"福善镇","510322120":"李桥镇","510322121":"赵化镇","510322122":"安溪镇","510322123":"万寿镇","510322124":"飞龙镇","510322125":"怀德镇","510322126":"长滩镇","510322200":"龙万乡","510322201":"宝庆乡","510322202":"富和乡","510322203":"石道乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510322.json
// module id = 2280
// module chunks = 0